import { useQuery } from "@tanstack/react-query";
import { getWeights } from "../../api/card";
import "./Weights.scss";
import { getCardColor, getCardImage } from "../../funcs/card";
import { CONFIG } from "../../assets/configs/config";
import StarSvg from "../../assets/svg/StarSvg";
import KeySvg from "../../assets/svg/KeySvg";

function Weights() {
    const {data: weights} = useQuery({
        queryKey: ["weights"],
        queryFn: getWeights,
    });

    const sortByRarity = (entries) => {
        return entries.sort(([a], [b]) => {
            return CONFIG.rarityOrder.indexOf(a) - CONFIG.rarityOrder.indexOf(b);
        });
    };

    if (!weights) return null;

    return (
        <div className="weights-wrapper">
            <div className="weights">
                <div className="title">
                    <StarSvg />
                    <span>Без премиума</span>
                </div>
                {sortByRarity(Object.entries(weights.default)).map(([rare, vl]) => 
                    <span key={Date.now() + Math.random().toString(36)} className="block" style={{color: getCardColor(rare)}}>
                        <span className="rare">
                            <img src={getCardImage(rare)} alt="card" />
                            {rare}
                        </span>
                        <span className="vl">{vl/10}%</span>
                    </span>
                )}
            </div>

            <div className="weights">
                <div className="title">
                    <KeySvg />
                    <span>С премиумом</span>
                </div>
                {sortByRarity(Object.entries(weights.premium)).map(([rare, vl]) => 
                    <span key={Date.now() + Math.random().toString(36)} className="block" style={{color: getCardColor(rare)}}>
                        <span className="rare">
                            <img src={getCardImage(rare)} alt="card" />
                            {rare}
                        </span>
                        <span className="vl">{vl/10}%</span>
                    </span>
                )}
            </div>
        </div>
    );
};

export default Weights;